<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="基地编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'baseNo', validatorRules.baseNo]" placeholder="请输入基地编码"></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'base', validatorRules.base]" placeholder="请输入基地"></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="角色id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'roleId', validatorRules.roleId]" placeholder="请输入角色id"></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="星期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workDay', validatorRules.workDay]" placeholder="请输入星期"></a-input>
        </a-form-item>
        <a-form-item label="用户编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'userNo', validatorRules.userNo]" placeholder="请输入用户编号"></a-input>
        </a-form-item>
        <a-form-item label="用户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'userName', validatorRules.userName]" placeholder="请输入用户姓名"></a-input>
        </a-form-item>
        <a-form-item label="分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select :allowClear="true" v-decorator="[ 'groupId', validatorRules.groupId]" :options="groupOption" @change="handleGroupIdChange" placeholder="请选择分组"></a-select>
        </a-form-item>
        <a-form-item label="车间明细" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea   readOnly :value="groupNameStr" :auto-size="{ minRows: 3 }" placeholder="请输入用户姓名"></a-textarea>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction,getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import {findGroupWorkshopByGroupId} from '@/api/api'

  export default {
    name: "BusInspectionGroupUserConfigModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          groupId: {rules: [
          ]},
          roleId: {rules: [{ required: true, message: 'Please input your note!' }
          ]},
          userNo: {rules: [
          ]},
          userName: {rules: [
          ]},
          workDay: {rules: [
          ]},
          baseNo: {rules: [
          ]},
          base: {rules: [
          ]},
        },
        url: {
          add: "/group/busInspectionGroupUserConfig/add",
          edit: "/group/busInspectionGroupUserConfig/edit",
        },
        groupOption:[],
        groupNameList:[],
      }
    },
    created () {
    },
    methods: {
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        let params={
          pageNo:1,
          pageSize:999,
          base:record.base
        }
        this.groupOption=[]
        getAction("/group/busInspectionGroup/list", params).then((res) => {
            if (res.success) {
                this.groupOption = res.result.records.map((item)=>{
                  return{
                    groupName:item.groupName,
                    groupId:item.id,
                    label:item.groupName,
                    value:item.id,
                  }
                });
            }else{
                this.$message.warning(res.message)
            }  
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'groupId','roleId','userNo','userName','workDay','baseNo','base'))
          this.handleGroupIdChange(this.model.groupId)
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            
            for (const iterator of this.groupOption) {
              if(iterator.groupId==values.groupId){
                values.groupName=iterator.groupName
              }
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction("/group/busInspectionGroupUserConfig/add",formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'groupId','roleId','userNo','userName','workDay','baseNo','base'))
      },
      handleGroupIdChange(value){
        this.groupNameList=[]
        if(!value){
          return
        }
        findGroupWorkshopByGroupId({groupId:value}).then((res)=>{
          if(res.code==200){
            this.groupNameList=res.result.map(item=>{
              return item.depart+item.workshop
            })
          }
        }).catch((err)=>{
          this.$message.error(err.message)
        })
      }
    },
    computed:{
      groupNameStr(){
        if(this.groupNameList.length>0){
          return this.groupNameList.join("; ")
        }else{
          return ""
        }
      }
    }
  }
</script>